import { IconPieChart } from 'components/Icon/IconPieChart'
import { useDeductiblesQuery } from 'queries/deductibles/deductibles'
import { usePlansQuery } from 'queries/plans'
import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { DeductibleStatusCard } from '../DeductibleStatusCard/DeductibleStatusCard'

type CurrentDeductiblesProps = {
  className?: string
}
export const CurrentDeductibles = ({ className }: CurrentDeductiblesProps) => {
  const { t } = useTranslation('accountHome')

  // Deductibles query is dependent upon successful plans query
  const { data: planData, isError: plansError } = usePlansQuery()

  const { data, isLoading, isError } = useDeductiblesQuery({
    enabled: !!planData
  })

  const currentYear = new Date().getFullYear()

  // TODO - possibly update API endpoint to deliver numbers rather than parsing here
  const currentDeductibles = useMemo(() => {
    if (!data?.deductibleList?.length) {
      return null
    }
    const curr = data.deductibleList.find(
      (item) => Number(item.deductibleYear) === currentYear
    )
    return {
      deductible: Number(curr?.deductibleAmount.replace(/[^0-9.-]+/g, '')),
      amountPaid: Number(curr?.deductibleAmountMet.replace(/[^0-9.-]+/g, ''))
    }
  }, [currentYear, data?.deductibleList])

  return (
    <section
      className={`account-home-section current-deductibles ${className}`}
    >
      <div className="icon">
        <IconPieChart ariaHidden />
      </div>
      <h2 className="ds-text-heading--xl">
        {t('currentDeductibles.heading', { year: currentYear })}
      </h2>
      <div className="content my-u-pb--32">
        <DeductibleStatusCard
          amountPaid={currentDeductibles?.amountPaid || 0}
          deductible={currentDeductibles?.deductible || 0}
          isLoading={(isLoading || !currentDeductibles?.deductible) && !isError}
          isError={isError || plansError}
        />
      </div>
    </section>
  )
}
